export const palette = {
    common: {
        white: "#FFFFFF",
        black: "#000000"
    },
    primary: {
        main: "rgba(0, 83, 229, 1)",
        light: "#8BA2FF",
        dark: "#0041CD",
        contrastText: "rgba(255, 255, 255, 1)"
    },
    secondary: {
        main: "#03194F",
        dark: "#000716",
        light: "#7F8CED",
        contrastText: "rgba(255, 255, 255, 1)"
    },
    error: {
        main: "rgba(244, 67, 54, 1)",
        dark: "#E31B0C",
        light: "#F88078",
        contrastText: "rgba(255, 255, 255, 1)"
    },
    warning: {
        main: "#ED6C02",
        dark: "#C77700",
        light: "#FFB547",
        contrastText: "rgba(255, 255, 255, 1)"
    },
    info: {
        main: "rgba(33, 150, 243, 1)",
        dark: "rgba(11, 121, 208, 1)",
        light: "rgba(100, 182, 247, 1)",
        contrastText: "rgba(255, 255, 255, 1)"
    },
    success: {
        main: "#4CAF50",
        dark: "rgba(59, 135, 62, 1)",
        light: "#4CAF50",
        contrastText: "rgba(255, 255, 255, 1)"
    },
    // We are using it only for the notification.
    // TODO: Change the notification to use Snackbar without Alert inside when the type is neutral and remove this entry from here.
    neutral: {
        main: "rgba(50, 50, 50, 1)",
        dark: "rgba(59, 135, 62, 1)",
        light: "rgba(189, 189, 189, 1)",
        contrastText: "rgba(255, 255, 255, 1)"
    },
    white: {
        main: "rgba(255, 255, 255, 1)",
        dark: "#FFFFFF",
        light: "#FFFFFF",
        contrastText: "rgba(0, 0, 0, 0.6)"
    },
    gradient: {
        main: "rgba(0, 83, 229, 1)",
        light: "#8BA2FF",
        dark: "#0041CD",
        contrastText: "rgba(255, 255, 255, 1)"
    },
    grey: {
        50: "#FAFAFA",
        100: "#F5F5F5",
        200: "#EEEEEE",
        300: "#E0E0E0",
        400: "#BDBDBD",
        500: "#9E9E9E",
        600: "#757575",
        700: "#616161",
        800: "#424242",
        900: "#212121",
        A100: "#D5D5D5",
        A200: "#AAAAAA",
        A400: "#616161",
        A700: "#303030"
    },
    text: {
        primary: "rgba(0, 0, 0, 0.87)",
        secondary: "rgba(0, 0, 0, 0.6)",
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    divider: "rgba(0, 83, 229, 0.12)",
    background: {
        paper: "#FFFFFF",
        default: "#FFFFFF"
    },
    action: {
        active: "rgba(0, 0, 0, 0.56)",
        hover: "rgba(0, 83, 229, 0.06)",
        hoverOpacity: 0.06,
        selected: "rgba(68, 87, 255, 0.1)",
        selectedOpacity: 0.1,
        disabled: "rgba(0, 0, 0, 0.38)",
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.14
    },
    other: {
        editorBackground: "#F4F7FF"
    },
    brand: {
        gradientBlackBlue: `
            #0054E5,
            #014BCE,
            #0142B7,
            #023AA1,
            #03318C,
            #032977,
            #032163,
            #03194F
        `,
        gradientMagentaBlue: "#E689F1 15.69%, #D47FEF 25.23%, #C175EE 34.78%, #AB6DEC 44.32%, #9365EB 53.86%, #775EE9 63.41%, #5358E7 72.95%, #0053E5 82.49%",
        gradientMagentaOrange: `
            #E689F1,
            #F27DDF,
            #FC72CB,
            #FF68B6,
            #FF5FA0,
            #FF588A,
            #FF5573,
            #FC545D
        `
    }
};
//# sourceMappingURL=palette.js.map